import { Skeleton } from "@mantine/core";

import classes from "../../styles/pages/TemplateEditionPage.module.scss";

export function FormSkeleton() {
  return (
    <form>
      <Skeleton height={35} radius="xl" />{" "}
      <div className={classes.editor}>
        <Skeleton height={35} radius="xl" />
      </div>
      <div className={classes.editor}>
        <Skeleton height={700} radius="xl" />
      </div>
    </form>
  );
}
